export default __webpack_public_path__ + "static/media/earphones15.59b653dc.jfif";